
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import medical1 from '../medical/medical1.jpg';
import medical2 from '../medical/medical2.jpg';
import medical3 from '../medical/medical3.jpg';
import medical4 from '../medical/medical4.jpg';
import medical5 from '../medical/medical5.jpg';

const images = [
  {
    src: medical1,
    caption: 'Madras Medical College',
  },
  {
    src: medical2,
    caption: 'Stanley Medical College',
  },
  {
    src: medical3,
    caption: 'Christian Medical College Vellore',
  },
  {
    src: medical4,
    caption: 'Madurai Medical College',
  },
  {
    src: medical5,
    caption: 'Kilpauk Medical College',
  },
];

export default function SlideshowBackground() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="absolute inset-0 w-full h-full z-0 overflow-hidden">
      <AnimatePresence initial={false}>
        {images.map((img, idx) =>
          idx === current ? (
            <motion.img
              key={img.caption + '-' + idx}
              src={img.src}
              alt={img.caption}
              className="object-cover w-full h-full absolute inset-0 z-10"
              draggable={false}
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -100, opacity: 0 }}
              transition={{ duration: 0.8, ease: 'easeInOut' }}
            />
          ) : null
        )}
      </AnimatePresence>
      {/* Overlay for darkening and readability */}
      <div className="absolute inset-0 bg-black bg-opacity-30 pointer-events-none" />
      {/* Caption overlay */}
      <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/80 to-transparent text-white text-lg md:text-2xl font-semibold px-6 py-4 z-20 text-shadow-lg select-none">
        {images[current].caption}
      </div>
    </div>
  );
}
